import React, { Component } from "react";
import { getDecodedHtml } from "utils/getDecodedHtml";

class MaterialBoxDownloadThankYou extends Component {
	render() {
		const { successMessage } = this.props.data.modal.successMessage;
		return (
			<div
				className="material-box-modal-thankYou"
				dangerouslySetInnerHTML={{ __html: getDecodedHtml(successMessage) }}
			></div>
		);
	}
}
export default MaterialBoxDownloadThankYou;
